module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }